export const RESET = "FEED_UPDATE_RESET";
export const SET_ERROR = "FEED_UPDATE_SET_ERROR";
export const SET_RETRIEVED = "FEED_UPDATE_SET_RETRIEVED";
export const SET_UPDATED = "FEED_UPDATE_SET_UPDATED";
export const SET_VIOLATIONS = "FEED_UPDATE_SET_VIOLATIONS";
export const TOGGLE_LOADING = "FEED_UPDATE_TOGGLE_LOADING";
export const UPDATE_RETRIEVED = "FEED_UPDATE_UPDATE_RETRIEVED";
